var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isShow
      ? _c("div", { staticClass: "mask" }, [
          _c("div", { staticClass: "goods-pop-wrap" }, [
            _c(
              "div",
              { staticClass: "send-goods send-goods1 one-con goods-visible" },
              [
                _c("div", { staticClass: "send-goods-star" }),
                _c("div", { staticClass: "send-goods-star2" }),
                _c("div", { staticClass: "send-goods-meteor" }),
                _c("div", { staticClass: "send-goods-meteor2" }),
                _c("div", { staticClass: "send-goods-meteor3" }),
                _c("div", { staticClass: "send-goods-meteor4" }),
                _c("div", { staticClass: "send-goods-top" }),
                _c("div", { staticClass: "send-goods-bottom" }),
                _vm.isMyself &&
                _vm.case_opened_awards.length != _vm.garbageAwardList.length
                  ? [
                      _vm.case_opened_awards.length >
                      _vm.awardsConvertList.length
                        ? _c("div", { staticClass: "con-title" }, [
                            _vm._v("获得新物品"),
                          ])
                        : _vm._e(),
                      _vm.case_opened_awards.length ==
                      _vm.awardsConvertList.length
                        ? _c("div", { staticClass: "con-title" }, [
                            _vm._v("查看奖品"),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm.isMyself &&
                _vm.case_opened_awards.length == _vm.garbageAwardList.length
                  ? [
                      _vm.case_opened_awards.length >
                      _vm.awardsConvertList.length
                        ? _c("div", { staticClass: "con-title" }, [
                            _vm._v("凉凉奖励"),
                          ])
                        : _vm._e(),
                      _vm.case_opened_awards.length ==
                      _vm.awardsConvertList.length
                        ? _c("div", { staticClass: "con-title" }, [
                            _vm._v("查看奖品"),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
                !_vm.isMyself
                  ? _c("div", { staticClass: "con-title" }, [
                      _vm._v("获奖名单"),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "send-goods-bd" }, [
                  _c(
                    "div",
                    { staticClass: "send-goods-list" },
                    _vm._l(_vm.case_opened_awards, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "item-wrap" },
                        [
                          _vm.isMyself
                            ? [
                                !item.isConvert
                                  ? _c(
                                      "div",
                                      { staticClass: "list-item item-general" },
                                      [
                                        _c("c-award", {
                                          staticClass: "c-award",
                                          attrs: {
                                            rarity: item.rarity,
                                            picture: item.itempic,
                                            name: item.name,
                                            price: item.price,
                                          },
                                        }),
                                        item.roll
                                          ? _c("div", { staticClass: "roll" }, [
                                              _vm._v(
                                                "Roll点 " + _vm._s(item.roll)
                                              ),
                                            ])
                                          : _vm._e(),
                                        _c("div", { staticClass: "price" }, [
                                          _vm._v("价值 " + _vm._s(item.price)),
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "btn-store-backpack",
                                            class: { disabled: item.isConvert },
                                            on: {
                                              click: function ($event) {
                                                return _vm.case_opened_awards_discount(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.isConvert
                                                    ? "已售出"
                                                    : "售出"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : [
                                _c(
                                  "div",
                                  { staticClass: "list-item item-general" },
                                  [
                                    _c("c-award", {
                                      staticClass: "c-award",
                                      attrs: {
                                        rarity: item.rarity,
                                        picture: item.itempic,
                                        name: item.name,
                                        price: item.price,
                                      },
                                    }),
                                    item.roll
                                      ? _c("div", { staticClass: "roll" }, [
                                          _vm._v("Roll点 " + _vm._s(item.roll)),
                                        ])
                                      : _vm._e(),
                                    _c("div", { staticClass: "price" }, [
                                      _vm._v("价值 " + _vm._s(item.price)),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "btn-store-backpack" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.awardPlayerName) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]),
                _c("div", {
                  staticClass: "close-btn",
                  on: { click: _vm.reset },
                }),
                _vm.isMyself &&
                _vm.case_opened_awards.length > _vm.awardsConvertList.length
                  ? _c("div", { staticClass: "send-goods-btns" }, [
                      _c(
                        "div",
                        {
                          staticClass: "resolve-btn",
                          on: {
                            click: function ($event) {
                              return _vm.case_opened_awards_discount(null)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "currency" },
                            [
                              _c("c-number", {
                                attrs: {
                                  duration: 2000,
                                  from: 0,
                                  to: _vm.case_opened_awards_amount,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.case_opened_awards.length !=
                      _vm.garbageAwardList.length
                        ? _c(
                            "div",
                            {
                              staticClass: "more-btn",
                              on: { click: _vm.reset },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.case_opened_awards.length > 1
                                    ? "批量存入背包"
                                    : "存入背包"
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }